// SMS consent checkbox (A2P 10DLC / CTIA point-of-collection disclosure).
// Unchecked by default, required — active consent (Twilio error 30925). Text
// names the program, frequency, rates, opt-out/help, and links the privacy
// policy (mobile numbers never shared) + terms. Client-side gate only; the
// value is not persisted to Firestore.
export function SmsConsent({ value, onChange, error }) {
  return (
    <label class="field sms-consent">
      <span class="sms-consent-row">
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.currentTarget.checked)}
          aria-invalid={!!error}
        />
        <span class="sms-consent-text">
          Yes, text me about my stay! Julie at One Beach Road sends a handful
          of booking texts per reservation — never marketing, and she never
          shares your number with anyone. Message and data rates may apply.
          Reply STOP to opt out, HELP for help.{" "}
          <a href="https://onebeachroad.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>
          {" | "}
          <a href="https://onebeachroad.com/terms" target="_blank" rel="noopener">Terms</a>
        </span>
      </span>
      {error ? <span class="field-error">{error}</span> : null}
    </label>
  );
}
